export var getBannerState = function (state) {
    var _a, _b;
    return (_b = (_a = state.engagement) === null || _a === void 0 ? void 0 : _a.engageV2) === null || _b === void 0 ? void 0 : _b.banners;
};
export var getVisibleBanner = function (state) {
    var _a;
    return ((_a = getBannerState(state)) === null || _a === void 0 ? void 0 : _a.visibleBanner) || null;
};
export var getBannerHandlers = function (state) {
    var _a;
    return ((_a = getBannerState(state)) === null || _a === void 0 ? void 0 : _a.handlers) || {};
};
export var getIsBannerDismissed = function (state, bannerType) {
    var _a, _b;
    return ((_b = (_a = getBannerState(state)) === null || _a === void 0 ? void 0 : _a.dismissedBanners) === null || _b === void 0 ? void 0 : _b.includes(bannerType)) || false;
};
